<template>
<div>
    <h2 class="text-center mb-4 pb-2 text-primary fw-bold">Application Features</h2>
    <b-card-group columns class="ml-3 mr-3">
    <b-card
      title="Twilio Integration"
      class="rounded-0"
      bg-variant="dark"
      text-variant="white"
      >
      <b-card-text>
        <ul>
          <li>Use Verify to validate contact phone numbers when adding contacts</li>
          <li>Fetch current twilio account balance to manage sending messages cost</li>
          <li>Use most up to date carrier fees to accurately estimate message costs</li>
          <li>Use phone number webhook integration to receive inbound messages.</li>
          <li>Available whatsapp integration to further reach contacts</li>
        </ul>
      </b-card-text>
    </b-card>

    <b-card
      title="Organizations and Groups"
      class="rounded-0"
      bg-variant="primary"
      text-variant="white"
      >
      <b-card-text>
        <ul>
          <li>Organize contacts through groups</li>
          <li>Include other organizations to as part of an organization</li>
          <li>Customize message greetings per groups</li>
          <li>Customize message signatures per groups</li>
          <li>Customize greeting message</li>
          <li>Select default greeting language [*Currently supports ENG, SPA, POR]</li>
          <li>Add additional message languages per group [*Currently supports ENG, SPA, POR]</li>
          <li>Notification Emails: Add emails to notify when inbound messages are received.</li>
          <li>Bulk update contacts, ADD/REMOVE or SWITCH</li>
        </ul>
      </b-card-text>
    </b-card>
    <b-card
      title="Contact Management"
      class="rounded-0"
      bg-variant="success"
      text-variant="white"
      >
      <b-card-text>
        <ul>
          <li>Save minimal information about contacts</li>
          <li>Record unsubscribe from twilio API</li>
          <li>Track contact carrier and phone type</li>
          <li>Select preferred language to use for greetings/messages</li>
          <li>Select title to use in message</li>
          <li>Select a primary organization</li>
          <li>Include in aux organizations</li>
          <li>Select gender of contact to auto generate greeting message</li>
          <li>Bulk import records from excel files</li>
          <li>Send enrollment when creating a contact [when enabled]</li>
        </ul>
      </b-card-text>
    </b-card>
    <b-card
      title="Message Administration"
      class="rounded-0"
      bg-variant="dark"
      text-variant="white"
      >
      <b-card-text>
        <ul>
          <li>Target SMS messages by selecting a single group</li>
          <li>Create single message in different languages and target based on contact preferences.</li>
          <li>Schedule a message to be sent at a specific date/time</li>
          <li>Override message greeting, default is based on organization</li>
          <li>Override message signature, default is bsed on organization</li>
          <li>Preview message cost before sending</li>
          <li>Identify encoding of message [UCS] vs [GSM] and compose accordingly.</li>
          <li>Short URL long links in messages</li>
          <li>Add 1 time use phone numbers to messages.</li>
          <li>Save a message to be sent at a later time</li>
          <li>Outbound message view</li>
          <li>Inbound message view</li>
          <li>AutoReply messages when sending inbound messages [if enabled]</li>
        </ul>
      </b-card-text>
    </b-card>
    <b-card
      title="Appointment Management"
      class="rounded-0"
      bg-variant="dark"
      text-variant="white"
      >
      <b-card-text>
        <ul>
          <li>Allow users to schedule appointments with selected reasons</li>
          <li>Messaging capabilities through Twilio</li>
          <li>Schedule contacts to receive reminders through sms/whatsapp about upcoming appointments</li>
          <li>Schedule appointments for a single contact or multiple contacts</li>
          <li>Mobile friendly</li>
          <li>Ward test mode to test appointment scheduling.</li>
        </ul>
      </b-card-text>
    </b-card>
    <b-card
      title="Security & Accessibility"
      class="rounded-0"
      bg-variant="primary"
      text-variant="white"
      >
      <b-card-text>
        <ul>
          <li>Allow users to have access to specific functions.</li>
          <li>Have users access to only access specific organizations</li>
          <li>Timed user sessions to ensure security</li>
          <li>Encrypted access to application</li>
          <li>Mobile friendly</li>
          <li>Modify ward information</li>
          <li>Ward test mode to test message sending.</li>
        </ul>
      </b-card-text>
    </b-card>
    <b-card
      title="Try the Demo"
      class="rounded-0"
      bg-variant="dark"
      text-variant="white"
      >
      <b-card-text>
        <b-button variant="primary" :to="{name: 'contact'}" class="ml-2">Request Demo Access</b-button>
      </b-card-text>
    </b-card>
    </b-card-group>
</div>
</template>
<script>

export default {
  name: 'Features',
  data () {
      return {
          items: [
            {
              text: 'Home',
              to: { name: 'home' }
            },
            {
              text: 'Features',
              active: true
            }
          ]
      }
  }
}
</script>
